import { useMediaQuery } from './use-media-query';

const DRAGGABLE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';

export function usePointerInteractivity(): boolean {
	return useMediaQuery(DRAGGABLE_POINTER_QUERY);
}
